import { useCallback } from 'react'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { useSnackbar } from 'notistack'
import { useCreateShiftMutation } from '@/core/services/planning'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { useAppSelector } from '@/redux/rootReducer'
import { getApiErrorMessage } from '@/utils/errors'

export function useCreateShift(planningId: string, shiftTemplateId: string, startTime: string, endTime: string) {
  useLingui()
  const { enqueueSnackbar } = useSnackbar()

  const authUser = useAppSelector(selectAuthUser)
  const [createShiftMutation, { isLoading: isCreatingShift }] = useCreateShiftMutation()

  const createShift = useCallback(async (onCompleted?: () => void) => {
    if (!authUser?._id) return

    try {
      await createShiftMutation({
        planningId,
        shiftTemplateId,
        startTime,
        endTime,
        staffId: authUser._id,
      }).unwrap()
      enqueueSnackbar(t`Shift has been created successfully`, { variant: 'success' })
      onCompleted?.()
    } catch (error) {
      enqueueSnackbar(getApiErrorMessage(error), { variant: 'error' })
    }
  }, [])

  return [createShift, isCreatingShift] as const
}
